/**
 * API基础地址
 */

let url = "/";
if (process.env.NODE_ENV !== "development") {
  // url = "http://139.9.243.5:8100/";
}

export const API_BASE_URL = url;

// export const API_BASE_URL = "/api";
// export const API_BASE_URL = "http://192.168.2.185:8000/";
// export const API_BASE_URL = "http://139.9.243.5:8100/";

/**
 * python 业务模块调用服务地址
 */
export const SERVICE_URL = "api/service";

/**
 * RabbitMQ Stomp 服务配置
 */
export const WS_MQ_URL = {
  url: "ws://127.0.0.1:15674/ws",
  user: "admin",
  pwd: "1qaz@WSX"
};

export const WS_URL = "ws://127.0.0.1:8183/";
